import {ApiClient} from '@hconnect/apiclient'

import {Main} from './Main'
import {GlobalProviders} from './providers/GlobalProviders'

export const App: React.FC = () => {
  return (
    <GlobalProviders api={ApiClient.axiosInstance}>
      <Main />
    </GlobalProviders>
  )
}
